import { Modal } from 'antd';
import React from 'react';
import { ContractorActivity } from '../../types';
import ActivityConnectedForm from './ActivityConnectedForm';

type Props = {
  record?: ContractorActivity;
  timesheetId?: string;
  showModal: boolean;
  close: () => void;
  onSave?: () => void;
};

class ActivityModalForm extends React.Component<Props> {
  render(): React.ReactElement {
    if (!this.props.showModal || !this.props.record || !this.props.timesheetId) {
      return <></>;
    }
    return (
      (<Modal open={this.props.showModal} onCancel={this.props.close} footer={null}>
        <ActivityConnectedForm
          close={this.props.close}
          onSave={this.props.onSave}
          record={this.props.record}
          timesheetId={this.props.timesheetId}
        />
      </Modal>)
    );
  }
}

export default ActivityModalForm;
